var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckboxDone = function SvgCheckboxDone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#475467",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "m4 10 1.333 1.334 3-3m-3-3V3.467c0-.747 0-1.12.146-1.405.127-.251.331-.455.582-.583.285-.146.659-.146 1.406-.146h5.066c.747 0 1.12 0 1.406.146.25.128.454.332.582.583.146.285.146.658.146 1.405v5.067c0 .746 0 1.12-.146 1.405-.128.25-.332.455-.582.582-.286.146-.659.146-1.406.146h-1.866m-7.2 4h5.066c.747 0 1.12 0 1.406-.146.25-.127.454-.331.582-.582.146-.285.146-.659.146-1.405V7.467c0-.747 0-1.12-.146-1.405a1.33 1.33 0 0 0-.582-.583c-.286-.146-.659-.146-1.406-.146H3.467c-.747 0-1.12 0-1.406.146-.25.128-.455.332-.582.583-.146.285-.146.658-.146 1.405v5.067c0 .746 0 1.12.146 1.405.127.25.331.455.582.582.285.146.659.146 1.406.146"
  })));
};
export default SvgCheckboxDone;